<template>

  <!--地图容器-->
  <div>
    <div id="XSDFXPage" class="XSDFXPage" style="float:left"  v-loading="loading"
    element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" ></div>

    <div id="chooseNumShow">
        <div class="input-card"  id="mapType">
            <div class="input-item">
                <button v-on:click="hideLayer($event)" class="btn selected">标准</button>
                <button v-on:click="showLayer($event)" class="btn">卫星</button>
                <button  type="button" class="el-button el-button--default el-button--mini is-circle showFormBtn"  @click="showForm" ><i class="el-icon-search"></i></button>
                <button  type="button" class="el-button el-button--danger el-button--mini is-circle hideFormBtn"  @click="hideForm" ><i class="el-icon-close"></i></button>
                <button  type="button" class="el-button el-button--default el-button--mini is-circle"  @click="refreshMap" ><i class="el-icon-refresh"></i></button>
            </div>
        </div>
    </div>

    <div id="deviceTable" >
        <el-col class="toolbar" style="padding-bottom: 0px;height:60px" >
			<el-form :inline="true"  size="mini">
				<el-form-item>
					<el-input v-model="projectName" placeholder="请输入名称" style="width: 120px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getFilterDevices()" size="mini">查询</el-button>
				</el-form-item>
			</el-form>
        </el-col>
        <el-table :data="devicesRight" border highlight-current-row @row-dblclick="chooseMarker" :height="formHeight"  size="small">
			<el-table-column type="index" label="序号" ></el-table-column>
			<el-table-column prop="deviceName" label="名称"  sortable></el-table-column>
		</el-table>
    </div>
    <div id="toggleBtn" v-on:click="showTable()"></div>

    <div id="gisTuli">
        <div v-for="item in functionalAreaList"  :key="item.id" v-bind:style="('background:#'+(item.color))">{{item.name}}</div>
        <p style="margin-top:15px;font-weight: bold;">功能区名称</p>
    </div>

     <div id="indexForm">
        <el-form :inline="true" :model="filters" size="mini">
            <el-form-item label="项目名称">
                <el-select v-model="filters.projectId" placeholder="请选择项目名称" filterable>
                    <el-option
                        v-for="item in projects"
                        :label="item.name"
                        :value="item.projectId" :key="item.projectId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <my-button  @select-type="clickBtn" QueryButtonShow ResetButtonShow></my-button>
            </el-form-item>
        </el-form>
    </div>

        <!--Form界面-->
        <el-dialog title="详情" :visible.sync="detailVisible">
       <div style="overflow: hidden;">
            <div style="float:left;width:48%" :key="1">
                <h3 style="margin-top: 0;">点位详情：</h3>
               <ul  id="realUl">
                    <li style='width:400px'>点位名称:{{chooseObj.deviceName }}</li>
                   <li style='width:400px'>功能区类型:{{chooseObj.name }}</li>
                   <li style='width:200px'>经度: {{chooseObj.lnglat[0] }}</li>
                   <li style='width:200px'>纬度: {{chooseObj.lnglat[1] }}</li>
                   <li style='width:200px'>昼间限值: {{chooseObj.day }}dB</li>
                   <li style='width:200px'>夜间限值: {{chooseObj.night }}dB</li>

                   <li style='width:200px;' >等效声级Leq:{{chooseObj.n00001 }}dB</li>
               </ul>
               <h3>图片：</h3>
                <div v-if="picCount==0" style="text-align: center;font-weight: bold;margin: 10px;">暂未上传图片</div>
                <el-image  v-else   style=" height: 550px"  :src="picUrl"   :preview-src-list="picUrlList"> </el-image>
            </div>
           <div style="float:left;width:50%" class="map">
                <h3  style="margin-top: 0;">
                    污染日历图：
                    <el-radio-group v-model="dayType" size="mini" @input="getDayData">
                        <el-radio-button label="n00004">昼</el-radio-button>
                        <el-radio-button label="n00005">夜</el-radio-button>
                    </el-radio-group>
                </h3>
                <div  style=" height: 450px" >
                    <el-calendar v-model="calendarvalue" >
                        <template  slot="dateCell"  slot-scope="{date, data}" >
                            <div class="Userdate"   v-if="mapData.get (data.day)!=undefined">
                                <div  class="index_cal"  :style="'color:#fff;background:'+mapData.get (data.day)">{{ data.day.split('-')[2]}}</div>
                            </div>
                            <div class="Userdate"   v-else >
                                <div  class="index_cal"  >{{ data.day.split('-')[2]}}</div>
                            </div>
                        </template>
                    </el-calendar>
                    <div class="unes_unoe" style="width:80%;margin:0 auto">
                        <div  class="unes_we">
                            <div  class="une_text">正常</div>
                            <div  class="IEM_w col_1">{{ dialogCal.status1 }}</div>
                        </div>
                        <div  class="unes_we">
                            <div  class="une_text">超标</div>
                            <div  class="IEM_w col_2">{{ dialogCal.status2 }}</div>
                        </div>
                        <div  class="unes_we">
                            <div  class="une_text">无数据</div>
                            <div  class="IEM_w col_3">{{ dialogCal.status3 }}</div>
                        </div>
                    </div>
                </div>
                <h3>24小时噪声趋势图（Leq）：</h3>
                <div  style=" height: 200px" id="trendChart" ></div>
            </div>
       </div>
    </el-dialog>
</div>
</template>

<script>
    import { getFunctionalAreaList,getRealDataForWeb,selectNoiseTrend ,selectNoiseCalendar,getDevicePic,getProjects} from '../../api/api';
    import {formatDate,formatDateDay } from '../../../static/fun.js';
    import * as echarts from "echarts";

    import myButton from '../../components/myButton/index.vue'
   
    export default {
        props: {
            collapsed: {
                type: Boolean,
            },
        },
        components: { myButton},
        data () {
            return {
                devices:[],
                factorName:[],
                factorKey:[],
                chooseMn:'',
                chooseId:'',
                points:[],
                time:[],

                map:null,
                satellite:null,
                count:0,
                dataType:'minute',
                factor:'n00001',

                loading:false,

                // 右侧框
                projectName:'',
                devicesRight:[],
                formHeight:0,
                tableShow:false,

                center:[],
                functionalAreaMap:new Map(),
                functionalAreaList:[],
                diff:0,
				wsurl:window.configuration.wsUrlSecond,
                mnMap:new Map(),
                mnData:new Map(),
                socket:null,
                userType:sessionStorage.getItem('type'),
                filters:{
                    projectId:''
                },
                projects:[],
                socketMN:[],
				chooseMN:[],
				openStatus:false,
                detailVisible:false,
                chooseObj:{
                    name:'',
                    n00005:'',
                    n00004:'',
                    lnglat:['',''],
                    point:""
                },
                picCount:0,
                picUrl:'',
                picUrlList:[],
                calendarvalue:'',
                dayType:'n00004',
                mapData:new Map(),
                clickFirst:true,
                dialogCal:{
                    status1:0,
                    status2:0,
                    status3:0,
                },
                yestoday:'',
                charts:null,
                projectIdAll:''
            }
        },
        watch: {
            'collapsed': {
                handler (val) {
                    var width=parseFloat( document.getElementById("XSDFXPage").style.width);
                    if(this.collapsed){
                        document.getElementById("XSDFXPage").style.width=width+200+"px";
                    }else{
                        document.getElementById("XSDFXPage").style.width=width-200+"px";
                    }
                },
                deep: true
            },
        },
        methods: {
            clickBtn(type){
				if(type=="query"){
					this.getDevices();
				}else if(type=="reset"){
					this.reset();
				}
			},
            reset(){
                this.filters.projectId="";
            },
            refreshMap(){
                this.map.setFitView();
            },
            showForm(){
                document.getElementById("indexForm").style.display="block";
                document.getElementsByClassName("showFormBtn")[0].style.display="none";
                document.getElementsByClassName("hideFormBtn")[0].style.display="block";
            },
            hideForm(){
                document.getElementById("indexForm").style.display="none";
                document.getElementsByClassName("showFormBtn")[0].style.display="block";
                document.getElementsByClassName("hideFormBtn")[0].style.display="none";
            },
            //绑定按钮事件
            showLayer:function(e) {
                this.satellite.show();
                if(this.satellite3d!=null){
                    this.satellite3d.show();
                }
                document.getElementById("mapType").getElementsByTagName("button")[0].classList.remove("selected");
                e.srcElement.classList.add("selected");
            },//卫星
            hideLayer(e) {
                this.satellite.hide();
                if(this.satellite3d!=null){
                    this.satellite3d.hide();
                }
                document.getElementById("mapType").getElementsByTagName("button")[1].classList.remove("selected");
                e.srcElement.classList.add("selected");
            },//标准 
            initMarker(){  
                this.map.clearMap();
                var fac=this.factor;
                //对获取到的设备进行展示
                this.chooseMN=[];
                this.devices.forEach(item => {
                    var color=this.functionalAreaMap.get(item.functionalAreaId).color;
                    var onjNum=item[fac];
                    if(onjNum==null){
                        onjNum="-";
                    }
                    //创建标注
                    var marker = new AMap.Marker({
                        position:new AMap.LngLat(item.lnglat[0],item.lnglat[1]),
                        content:  '<div class="markSty" style="background:url(/static/'+color+'.png)">' +
                            ' <span class="labelName">'+onjNum+'</span></div>',
                        extData:item
                    });
                    // 设置鼠标划过点标记显示的文字提示
                    marker.setTitle(item.deviceName);

                    this.mnMap.set(item.mn,marker);
                    this.mnData.set(item.mn,item);

                    this.chooseMN.push(item.mn);

                    //将标注放大地图上
                    this.map.add(marker);
                    this.addClickHandler(marker);

                });

                if(!this.openStatus){
                    return;//还未连接成功
                }

                if(this.chooseMN.toString()!=this.socketMN.toString()){
                    if(this.socketMN.length>0){
                        this.closeWsReal(this.socketMN);
                    }
                    this.openWsReal(this.chooseMN);
                }
            },
            initOneMarker(obj){  
                if(obj.state!=undefined){//离线报文
                }else{
                    var mn=obj.mn;
                    var i=this.mnData.get(mn);
                    var moveFlag=false;
                    if(i!=undefined){
                        if(obj.lat!=undefined){
                            i.latitude=obj.lat;
                            i.longitude=obj.lng;
                            moveFlag=true;
                        }
                        i.n00001=obj.leq;

                        var color=this.functionalAreaMap.get(i.functionalAreaId).color;
                        var onjNum=i.n00001;
                        if(onjNum==null){
                            onjNum="-";
                        }

                        var mark=this.mnMap.get(mn);
                        mark.setContent('<div class="markSty" style="background:url(/static/'+color+'.png)">' +
                                ' <span class="labelName">'+onjNum+'</span></div>')
                        if(!moveFlag){
                        }else{
                            mark.setPosition(new AMap.LngLat(i.longitude,i.latitude));
                        }
					}
				}
            },
            //设备点击事件
            addClickHandler:function(target){
                var _this=this;
                  target.on('click', function(e) {
                    _this.calendarvalue=new Date();
                    _this.calendarvalue=formatDateDay(_this.calendarvalue);

                    var obj=JSON.parse(JSON.stringify(e.target.getExtData()));
                    obj.day=_this.functionalAreaMap.get(obj.functionalAreaId).day;
                    obj.night=_this.functionalAreaMap.get(obj.functionalAreaId).night;
                    obj.name=_this.functionalAreaMap.get(obj.functionalAreaId).name;
                    _this.chooseObj=obj;
                    _this.detailVisible=true;
                    _this.getPic();
                    _this.getDayData();
                    _this.selectNoiseTrend();
                    if(_this.clickFirst){
                        _this.initCalendar();
                        _this.clickFirst=false;
                    }
                  })
            },
            getPic(){
                let para = {
                    deviceId: this.chooseObj.deviceId
                };
                getDevicePic(para).then((res) => {
                    if(res.data.Result=="layout"){
                        this.$message({
                            message: "用户已离线，请重新登录",
                            type: 'error'
                        })
                        this.$router.push({ path: '/login' });
                        return;
                    }

                    var fileListShow=  res.data.data;
                    this.picCount= res.data.data.length;
                    this.picUrlList=[];
                    fileListShow.forEach(element => {
                        var url=window.configuration.resourceUrlPhoto+element.urlName;
                        this.picUrlList.push(url);
                    });

                    if(fileListShow.length>0){
                        this.picUrl=this.picUrlList[0];
                    }
                });
            },
            getDayData(){
            this.calendarvalue=formatDate(this.calendarvalue);
            var arr=this.calendarvalue.split('-');
            var starttime=arr[0]+"-"+arr[1];

            let para = {
                mn: this.chooseObj.mn,
                date: starttime
            };
            this.listLoading = true;
            //数据格式处理
            selectNoiseCalendar(para).then((res) => {
                this.listLoading = false;
                if(res.data.result==true||res.data.result=="true"){
                    var datas = res.data.datas;
                    let keys = Object.keys(datas);

                    this.mapData=new Map();
                    this.dialogCal.status1=0;
                    this.dialogCal.status2=0;
                    this.dialogCal.status3=0;
                    for (let index = 0; index < keys.length; index++) {
                        const element = keys[index];
                        var value=datas[element];
                        var color="#838b8b";
                        if(value!=null){
                            if(this.dayType=="n00004"){
                                var n00004=value.n00004;
                                if(n00004>this.chooseObj.day){
                                    color="#daa520";
                                    this.dialogCal.status2++;
                                }else{
                                    color="#228b22";
                                    this.dialogCal.status1++;
                                }
                            }else{
                                var n00005=value.n00005;
                                if(n00005>this.chooseObj.night){
                                    color="#daa520";
                                    this.dialogCal.status2++;
                                }else{
                                    color="#228b22";
                                    this.dialogCal.status1++;
                                }
                            }
                            this.mapData.set(element,color);
                        }else{
                            //判断是否为未来时间
                            var now = new Date();
                            var d1 = new Date(element);
                            var days=parseInt(now - d1) / 1000 / 3600 / 24 ;//天
                            if(days>2){
                                this.mapData.set(element,color);
                                this.dialogCal.status3++;
                            }
                        }
                    }
                }else{
                    this.$message({
                        message: "查询出错,请重试",
                        type: 'warn'
                    })
                    return;
                }
            });
            },
            selectNoiseTrend(){
            let para = {
                mn: this.chooseObj.mn,
                date: this.yestoday
            };
            this.listLoading = true;
            //数据格式处理
            selectNoiseTrend(para).then((res) => {
                this.listLoading = false;
                if(res.data.result==true||res.data.result=="true"){
                    var datas = res.data.datas;

                    var timeData=datas.dateTimeList;
                    var leqData=datas.leqList;

                    var diurnalInitialTime=datas.diurnalInitialTime;//6
                    var nightInitialTime=datas.nightInitialTime;//22

                    if(nightInitialTime==0){
                        nightInitialTime=24;
                    }

                    var xdata=[];
                    var ydata=[];
                    for (let index = 0; index < timeData.length; index++) {
                        const element = timeData[index];
                        var value=leqData[index];
                        var hour=element.split(" ")[1].split(":")[0];//获取小时
                        
                        xdata.push(hour);
                        if(value!=null){
                            var color="";
                            hour=parseInt(hour);
                            if(hour>diurnalInitialTime&&hour<=nightInitialTime){
                                if(value>this.chooseObj.day){
                                    color="#daa520";
                                }else{
                                    color="#228b22";
                                }
                            }else{
                                if(value>this.chooseObj.night){
                                    color="#daa520";
                                }else{
                                    color="#228b22";
                                }
                            }
                            var obj={
                                value: value,
                                itemStyle: {
                                    color: color
                                }
                            }
                            ydata.push(obj);
                        }else{
                            ydata.push("-");
                        }
                    }

                    var markLineObj={
                        data: [
                            { yAxis: this.chooseObj.night, name: '夜间限值' },
                            { yAxis: this.chooseObj.day, name: '昼间限值'  }
                        ],
                        label: {
                            color: "#daa520"
                        },
                        lineStyle: {
                            color: "#daa520"
                        }
                    } 
                    this.initChart(xdata,ydata,markLineObj);
                }else{
                    this.$message({
                        message: "查询出错,请重试",
                        type: 'warn'
                    })
                    return;
                }
            });
            },
            initChart(xdata,ydata,markLineObj){
                this.charts = echarts.init(document.getElementById("trendChart"));
                let option = {
                    color: ['#59a869'],
                    title: { text:this.title},
                    tooltip: { trigger: 'axis' },
                    xAxis: { data: xdata, name:'时间',},
                    yAxis:  { type: 'value', name:'噪声值(dB)'},
                    grid: {
                        left: '10%',
                        right: '10%',
                        bottom: '5%',
                        top:40,
                        containLabel: true
                    },
                    series:  {  
                        type: 'bar',data: ydata,
                        markLine: markLineObj
                    }
                }
                this.charts.setOption(option);
            },
            initCalendar(){
                this.$nextTick(() => {
                    // 点击上个月
                    let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
                    prevBtn.addEventListener('click', () => {
                        this.calendarvalue=formatDateDay(this.calendarvalue);
                        this.getDayData();
                    })
                    // 点击今天
                    let currBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2)');
                    currBtn.addEventListener('click', () => {
                        this.calendarvalue=formatDateDay(this.calendarvalue);
                        this.getDayData();
                    })
                    // 点击下个月
                    let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
                    nextBtn.addEventListener('click', () => {
                        this.calendarvalue=formatDateDay(this.calendarvalue);
                        this.getDayData();
                    })
                })
            },
            drawLineChart:function(aData,seriesData,yData) {
                 // if(this.chartLine==null){
                    this.chartLine = echarts.init(document.getElementById('chartLine'));
                // }
                this.chartLine.setOption({
                    title: {
                        x:'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    toolbox: {
                        show : true
                    },
                    legend: {
                        data:this.factorName,
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                    },
                    grid: {
                        left: '5%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
                        data:aData
                    },
                    // yAxis: yData,
                    yAxis: {
                        type: 'value'
                    },
                    series:seriesData
                },true);
            },
            //获取筛选后的设备列表
            getFilterDevices(){
                this.devicesRight=[];
                this.devices.forEach(element => {
                    if(element.deviceName.indexOf(this.projectName)!=-1){
                        this.devicesRight.push(element);
                    }
                });
            },
            //点击右侧栏
            chooseMarker(row, event){
                var m3 = new AMap.Marker({
                    position: [row.lnglat[0], row.lnglat[1]],
                });
                this.map.setFitView([m3]);
            },
            showTable(){
                if(this.tableShow){
                    this.tableShow=false;
                    document.getElementById("XSDFXPage").style.width="100%";
                    document.getElementById("deviceTable").style.display="none";
                    document.getElementById("toggleBtn").style.backgroundPositionY="0";

                    document.getElementById("chooseNumShow").style.right= "5%";
                }else{
                    this.tableShow=true;
                    document.getElementById("XSDFXPage").style.width="80%";
                    document.getElementById("deviceTable").style.display="block";
                    document.getElementById("toggleBtn").style.backgroundPositionY="-32px";
                    document.getElementById("chooseNumShow").style.right="21%";

                }
            },
            //对地图进行渲染
            renderMap(){
                if(this.map==null){
                    // var scale = new AMap.Scale({ visible: true });

                    // 创建Map实例
                    this.map = new AMap.Map("XSDFXPage", {
                        resizeEnable: true
                    });
                    // this.map.addControl(scale);

                    this.satellite = new AMap.TileLayer.Satellite({ map:  this.map, });
                    this.satellite.hide();
                }
               
                this.initMarker();
                // 自适应显示多个点标记
                this.map.setFitView();
            },
              //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.listLoading = false;
					this.projects = res.data.data;
                    this.userType=sessionStorage.getItem('type');
                    if(this.userType=="0"&&this.projects.length>5){
                        if(this.projects.length>0){
                            this.filters.projectId=this.projects[0].projectId;
                        }
                    }
                    this.projectIdAll= this.projects.map(item => item.projectId).toString();
                    this.getDevices();
				});
			},
            //获取设备列表
			getDevices() {
                var param={
                    dataType:this.dataType
                } 
                if(this.filters.projectId!=""){
					param.proId=this.filters.projectId;
				}else{
                    param.proId=this.projectIdAll;
                }
				getRealDataForWeb(param).then((res) => {
                    this.devices = res.data.data;

                    this.devicesRight=this.devices;
                    this.renderMap();
				});
            },
            getFunctionalAreaList(){
				getFunctionalAreaList({}).then((res) => {
                    this.functionalAreaList=res.data.data;
                    res.data.data.forEach(element => {
						this.functionalAreaMap.set(element.id,element);
					});
                    this.getProjects();
				});
			},
            changeMapSize(){
                if(this.collapsed){
                    this.diff=200;
                }else{
                    this.diff=0;
                }
                 // 只关心高度 电脑高度734 地图高度610
                var value=734-610+60;
                var valueW=1080-946+150;
                var winHeight=document.body.clientHeight-value;
                var winWidth=document.body.clientWidth-valueW+this.diff;

                if(document.getElementById("XSDFXPage")!=null){
                    document.getElementById("XSDFXPage").style.height=winHeight+"px";
                    document.getElementById("XSDFXPage").style.width=winWidth+"px";
                }
            },
			websocketInit: function () {
				if(this.socket!=null){
					this.socket.close();
				}
				if (typeof WebSocket === "undefined") {
					alert("您的浏览器不支持socket");
				} else{
					// 实例化socket
					this.socket = new WebSocket(this.wsurl);//ws://xxxxx 
					// 监听socket错误信息
					this.socket.onerror = this.websocketError;
					// 监听socket消息
					this.socket.onmessage = this.websocketGetMessage;
					//连接成功建立的回调方法
					this.socket.onopen = this.websocketOpen;
                    this.socket.onclose = this.websocketClose;
				}
			},
			websocketOpen : function(event){
				console.log("socket连接成功");
                this.openStatus=true;
				//防止初次连接后数据未成功发送
				if(this.socketMN.length==0&&this.chooseMN.length!=0){
					this.openWsReal(this.chooseMN);	
				}
			},
			closeWsReal(socketMN){
				let dataTemp={ "mode":1, "state":0, "mnStr": socketMN.toString() };
				this.websocketSend(JSON.stringify(dataTemp));
			},
			openWsReal(chooseMN){
				let dataTemp={ "mode":1, "state":1, "mnStr": chooseMN.toString() };
				this.websocketSend(JSON.stringify(dataTemp));
				this.socketMN=chooseMN;
			},
            websocketClose : function(event){
				console.log("socket连接关闭");
			},
			websocketError: function () {
				console.log("socket连接错误");
			},
			websocketGetMessage: function (msg) {
				//处理数据 msg.data
				var obj=JSON.parse(msg.data);
                this.initOneMarker(obj);
			},
			websocketSend: function (params) {
				this.socket.send(params);
                console.log("发送数据"+params);
			},
		},
        beforeDestroy() {
            if(this.socketMN.length>0){
				this.closeWsReal(this.socketMN);
			}
            if (this.socket && this.socket.close !== null) {
				this.socket.close();
			}
		},
        mounted() {
            this.websocketInit();
            this.getFunctionalAreaList();
            this.changeMapSize();

            //窗口大小改变时
            var _this=this;
            window.onresize = function(){
                _this.changeMapSize();
            }

            var start = new Date();//2月12日 就是2.12/06:00--2.13/06:00 包前不包后
            start.setTime(start.setDate(start.getDate()-1));//昨天
            this.date=formatDateDay(start);
            this.yestoday=formatDateDay(start);

            var value=734-610+10;
            var winHeight=document.body.clientHeight-value;
			var timer2=null;
			clearInterval(timer2);
			timer2 =setInterval(function(){
				if(_this.formHeight ==0){
					_this.formHeight=winHeight-120;
				}else{
					clearInterval(timer2);
				}
			},10)
        }
    }
</script>
<style>
#XSDFXPage{
    width: 100%;
}

 #indexForm{
    position: absolute;
    top: -20px;
    left: 0;
    z-index: 999;
    background: #fff;
    padding: 20px;
    width: 100%;
    height: 100px;
    display: none;
    }
    .showFormBtn{
        display: block;
    }
    .hideFormBtn{
        display: none;
    }

    html,body{
        width: 100%;
        height: 100%;
        overflow: hidden;
        margin: 0;
        font-family: "微软雅黑";
    }  
    
    .anchorBL {  
        display: none;  
    } 
    #gisTuli{
        position: absolute;
        bottom: 5%;
        margin-left: 0%;
    }
    #gisTuli  div{
        width: 50px;
        height: 30px;
        /* float: left; */
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        color: #000;
    }
    #fac{
        height: 68%;
    }
    #chooseNumShow{
        position: absolute;
        bottom: 2%;
        right: 5%;
        height: 12%;
    }
    .input-card{
        position: static;
        float: left;
        width: auto;
        margin: 10px;
    }
    .input-card .selected{
        color:white;
        background: #25A5F7;
    }
    .markSty{
        position: relative;
        width: 36px;
        height: 30px;
        line-height: 30px;
        text-align: center;
    }
    .markSty span{
        position: relative;
        bottom: 3px;
    }
    #toggleBtn{
        background: url(/static/blueArrows.png) 0 0 no-repeat;
        cursor: pointer;
        width: 32px;
        height: 32px;
        opacity: 0.6;
        filter: alpha(opacity=60);
        display: block;
        background-size: 200% 200%;
        position: fixed;
        right:-6px;
        top:45%;
    }
    #deviceTable{
        display: none;
        width:16%;
        float:left;
        margin-left:2%;
    }

    #realUl{
        font-size:14px;
        overflow:hidden;
        width:500px;
        margin-top:10px;
    }
    #realUl li{
        list-style:none;
        float: left;
        min-width: 150px;
        min-height: 22px;
    }
    /* //tab切换 */
    #tab-head{
        height: 49px;
        border-bottom: 2px solid #bbb;
        margin-bottom: 10px;
    }
    #tab-head h2 {
        padding: 0 20px;
        height: 40px;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        position: relative;
        cursor: pointer;
    }
    
    #tab-head .selected {
        color: #409eff;
        border-bottom: 3px solid #409eff;
    }

    /* 图片滚动 */
    #picDiv{
        position: relative;
        display: none;
    }
    #outer{
        width: 300px;
        overflow: hidden;
        margin: 0 auto;
    }
    #inner{
        width: 5000px;
        min-height: 200px;
        overflow: hidden;
    }
    #inner img{
        width: 300px; 
        max-height: 280px!important;
        float: left;
    }
    #lft{
        width: 25px;
        height: 24px;
        background: url(/static/fx1.png) 0 0 no-repeat;
        position: absolute;
        left: 2%;
        top: 40%;
        cursor: pointer;
    }
    #rgt{
        width: 25px;
        height: 24px;
        background: url(/static/fx2.png) 0 0 no-repeat;
        position: absolute;
        right: 2%;
        top: 40%;
        cursor: pointer;
    }

    #XSDFX3dPage{
        display: none;
    }
    #outer{
        width: 300px;
        overflow: hidden;
        margin: 0 auto;
    }
    #inner{
        width: 5000px;
        min-height: 200px;
        overflow: hidden;
    }
    #inner img{
        width: 300px; 
        max-height: 100%!important;
        float: left;
    }
    #lft{
        width: 25px;
        height: 24px;
        background: url(/static/fx1.png) 0 0 no-repeat;
        position: absolute;
        left: 2%;
        top: 40%;
        cursor: pointer;
    }
    #rgt{
        width: 25px;
        height: 24px;
        background: url(/static/fx2.png) 0 0 no-repeat;
        position: absolute;
        right: 2%;
        top: 40%;
        cursor: pointer;
    }

    #fac{
        width: 30%;
        overflow-y: scroll;
    }
    .amap-marker-label{
        display: block;
        border: none;
        background-color: transparent;
    }
    

    #custom-info{
        background: #fff;
    }

     /* 自定义窗口 */
     .custom-info {
        border: solid 1px silver;
        background-color: white;
    }
    div.info-top {
        position: relative;
        background: none repeat scroll 0 0 #F9F9F9;
        border-bottom: 1px solid #CCC;
        border-radius: 5px 5px 0 0;
    }

    div.info-top div {
        display: inline-block;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        line-height: 31px;
        padding: 0 10px;
    }

    div.info-top img {
        position: absolute;
        top: 10px;
        right: 10px;
        transition-duration: 0.25s;
    }

    div.info-top img:hover {
        box-shadow: 0px 0px 5px #000;
    }

    div.info-bottom {
        height: 0px;
        width: 100%;
        clear: both;
        text-align: center;
    }

    div.info-bottom img {
        position: relative;
        z-index: 104;
    }
</style>


// WEBPACK FOOTER //
// GisShow.vue?41cc3ff2